if ($('.id--15').length) {
    $('h1').text(translation('objednavkaOdeslana'));
    $('.reca-number')
        .contents()
        .filter(function () {
            return this.nodeType === 3;
        })
        .first()
        .replaceWith(translation('recaNumber'));
    $('.co-payment-method h4.order-payment').text(translation('platbaAdoruceni'));
    $('.co-payment-method').after('<div class="co-personal-info co-box"></div>');

    $('.co-personal-info').append('<h4 class="order-icon"></h4>');
    $('.co-personal-info h4.order-icon').text(translation('osobniUdaje'));


    // bankovni prevod only
    if ($('.qrcode').length) {
        $('h4.order-icon.order-payment + .row .col-sm-6:last table tbody').prepend(
            '<tr class="totalPrice"></tr>'
        );
        $('.totalPrice').append('<th></th>');
        $('.totalPrice th').text($('strong[data-testid="orderTotalPrice"]').closest('tr').find('th').text().trim())
        $('.totalPrice').append('<td><strong>' + $('strong[data-testid="orderTotalPrice"]').text() + '</strong></td>');

        $('.qrcode').closest('div.co-box').addClass('qrcodeWrapper');

        $('.qrcodeWrapper .row').append($('.co-personal-info.co-box'));
        $('.qrcodeWrapper .row .col-sm-6:first').prepend($('.qrcodeWrapper>h4.order-payment'));
        $('.qrcode').closest('.col-sm-6').prepend('<h4 class="order-icon">' + translation('platebniUdaje') + '</h4>');
    }





    const userData = JSON.parse(sessionStorage.getItem("get_info"));
    $('.co-personal-info').append('<ul></ul>');
    var personalDataList = $('.co-personal-info ul');

    personalDataList.append('<li>' + userData[0].name + ' ' + userData[0].surname + '</li>');
    personalDataList.append('<li>' + userData[0].phone + '</li>');
    personalDataList.append('<li>' + userData[0].email + '</li>');
    personalDataList.append('<li>' + userData[0].street + '</li>');
    personalDataList.append('<li>' + userData[0].zip + ' ' + userData[0].city + '</li>');
    personalDataList.append('<li>' + userData[0].country + '</li>');


}

